import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ApiTest = () => {
  const [status, setStatus] = useState({
    apiUrl: process.env.REACT_APP_API_URL || 'NOT SET (using default)',
    backendHealth: 'Checking...',
    testResult: 'Not tested yet'
  });

  useEffect(() => {
    checkBackend();
  }, []);

  const checkBackend = async () => {
    try {
      // Test 1: Check backend health
      const healthResponse = await fetch(`${process.env.REACT_APP_API_URL || ''}/actuator/health`);
      const healthData = await healthResponse.json();
      
      setStatus(prev => ({
        ...prev,
        backendHealth: healthResponse.ok ? `✅ Backend is UP: ${JSON.stringify(healthData)}` : '❌ Backend returned error'
      }));

      // Test 2: Try fetching a question
      try {
        const questionResponse = await api.get('/api/questions/1');
        setStatus(prev => ({
          ...prev,
          testResult: `✅ Question API works! Question: ${questionResponse.data.title}`
        }));
      } catch (error) {
        setStatus(prev => ({
          ...prev,
          testResult: `❌ Question API failed: ${error.message}`
        }));
      }
    } catch (error) {
      setStatus(prev => ({
        ...prev,
        backendHealth: `❌ Cannot reach backend: ${error.message}`,
        testResult: 'Backend not reachable'
      }));
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8 pt-28">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">🔍 API Configuration Test</h1>
        
        <div className="bg-gray-800 rounded-lg p-6 mb-6">
          <h2 className="text-2xl font-bold mb-4">Environment Check</h2>
          <div className="space-y-3">
            <div className="flex items-start">
              <span className="font-semibold min-w-[200px]">REACT_APP_API_URL:</span>
              <span className="text-cyan-400 break-all">{status.apiUrl}</span>
            </div>
            <div className="flex items-start">
              <span className="font-semibold min-w-[200px]">Expected Value:</span>
              <span className="text-green-400">https://ycode-9ai5.onrender.com</span>
            </div>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 mb-6">
          <h2 className="text-2xl font-bold mb-4">Backend Health Check</h2>
          <p className="text-lg">{status.backendHealth}</p>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 mb-6">
          <h2 className="text-2xl font-bold mb-4">API Test Result</h2>
          <p className="text-lg">{status.testResult}</p>
        </div>

        <div className="bg-yellow-900/30 border border-yellow-600 rounded-lg p-6">
          <h3 className="text-xl font-bold mb-2">🎯 What This Means:</h3>
          <ul className="space-y-2 list-disc list-inside">
            <li>If REACT_APP_API_URL shows "NOT SET" - you need to set the environment variable</li>
            <li>If backend health fails - your Render backend might be sleeping (wait 30-60 seconds)</li>
            <li>If question API fails - there might not be a question with ID 1 in your database</li>
          </ul>
        </div>

        <button
          onClick={checkBackend}
          className="mt-6 bg-cyan-600 hover:bg-cyan-700 text-white px-6 py-3 rounded-lg font-semibold"
        >
          🔄 Re-test Connection
        </button>
      </div>
    </div>
  );
};

export default ApiTest;


